import type { ReactNode } from 'react'

// Shared visual for a subtype chip in the toolbox: icon + label.
export function ToolboxItemScaffold({ icon, name }: { icon: ReactNode; name: string }) {
  return (
    <div className="flex items-center gap-2">
      {icon}
      <span className="text-sm">{name}</span>
    </div>
  )
}
